import type { OrderStatus } from '@/domains/pjazza/types/consts/OrderStatus.consts.ts'
import type { PjazzaAccountOrder } from '@/domains/pjazza/types/models/PjazzaAccount.types.ts'

import { ORDER_STATUS, ORDER_STATUS_LABEL } from '@/domains/pjazza/types/consts/OrderStatus.consts.ts'
import { formatClockTime } from '@/domains/pjazza/utils/formatClockTime.ts'

/** The food is still coming, so its due time is worth showing. Once it is ready, that time says nothing. */
const isStillComing = (status: OrderStatus): boolean =>
  status === ORDER_STATUS.PENDING || status === ORDER_STATUS.ACCEPTED

/** "In the kitchen · ready around 13:40" — where a takeaway order is, and when it will be ready. */
export const orderProgressLabel = (status: OrderStatus, dueAt: string | null): string => {
  const label = ORDER_STATUS_LABEL[status] ?? status

  return dueAt && isStillComing(status) ? `${label} · ready around ${formatClockTime(dueAt)}` : label
}

/** "Ready around 13:40" once the till has set a time; until then, when it was placed. */
export const orderTimeLabel = (order: Pick<PjazzaAccountOrder, 'status' | 'dueAt' | 'placedAt'>): string => {
  if (order.status === ORDER_STATUS.READY) return 'Collect at the counter'

  if (order.dueAt) return `Ready around ${formatClockTime(order.dueAt)}`

  return `Placed ${formatClockTime(order.placedAt)}`
}
